import { render, staticRenderFns } from "./autoShortlistDialog.vue?vue&type=template&id=70769582&"
import script from "./autoShortlistDialog.vue?vue&type=script&lang=js&"
export * from "./autoShortlistDialog.vue?vue&type=script&lang=js&"
import style0 from "./autoShortlistDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports